import { Cols } from "../shared/Consts";
import usePortfolio from "../hooks/PortfolioProvider";
import { usePath } from "../libs/path/PathProvider";
import Utils from "../libs/Utils";
import Portfolio from "../models/Portfolio";
import PortUtils from "../portlibs/PortUtils";
import HoldingTable from "../components/widgets/HoldingTable";
import useDateRangeFilter from "../portlibs/DateRangeFilterProvider";
import HomeToolbar from "../components/home/HomeToolbar";
import { useCallback } from "react";

const COLS = [Cols.name, Cols.quantity, Cols.averagePrice, Cols.originalCost, Cols.holdingCost, Cols.currentPrice, Cols.holdingValue, Cols.dividend, Cols.profit, Cols.gain, Cols.mwPercent];
const COLS_FILTERED = [Cols.name, Cols.quantity, Cols.averagePrice, Cols.holdingCost, Cols.currentPrice, Cols.holdingValue, Cols.dividend, Cols.profit, Cols.gain, Cols.holdingPercent];
export default function SummaryPage(){
    const {query} = usePath()
    const {account,currency,filter,showDisposed} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const {end} = useDateRangeFilter()
    const cols = account<0 ? COLS : COLS_FILTERED

    let rows = portfolio.filter(currency, filter, account, true)
    if (!showDisposed) rows = rows.filter(row => !PortUtils.isZero(row.quantity))
    if (!PortUtils.dateEq(end, new Date())) {
        rows = PortUtils.trimHoldings(rows, end.getTime())
    }
    const footer = Portfolio.buildTotal(currency, rows, account>=0 || filter ? 0 : portfolio.getDeposits(account, currency))
    const onExport = useCallback(() => Utils.exportFile(PortUtils.toCSV(rows, cols), `Summary ${Utils.formatDate("yyyy-MM-dd", new Date())}.csv`), [rows])
    return <>
        <HomeToolbar onExport={onExport}/>
        <div id="summary" className="flex1 scroller">
            <HoldingTable tableName="home" cols={cols} rows={rows} footer={footer}/>
        </div>
    </>
}